import React from "react";
import "./icons.scss";

const CheckIcon = () => <>&#10003;</>;

const ErrorIcon = () => <>&#10008;</>;

const LoadingIcon = () => (
    <div className="lds-ripple">
        <div></div>
        <div></div>
    </div>
);

export { CheckIcon, ErrorIcon, LoadingIcon };
